import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { orderService } from '../services/orderService'

export const getAllOrders = createAsyncThunk('order/getAll', async (params = {}, { rejectWithValue }) => {
  try {
    const response = await orderService.getAll(params)
    return response
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const getOneOrder = createAsyncThunk('order/getOne', async (data, { rejectWithValue }) => {
  try {
    const response = await orderService.getOne(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})


const initialState = {
  data: { data: [], current_page: 1, per_page: 10, total: 0, last_page: 1 },
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllOrders.pending]: (state) => {
      if (state.data.data.length <= 0) {
        state.loading = true
      }
    },
    [getAllOrders.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllOrders.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneOrder.pending]: (state) => {
      state.loading = true
    },
    [getOneOrder.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneOrder.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
